import Queue from "nq-js";

class GetCurrentUserUseCase {
  execute(options) {
    return new Queue.User().getCurrentUser(options);
  }
}

export default GetCurrentUserUseCase;
